import { call, put, takeLatest, select } from "redux-saga/effects";
import remoteResource from "../../lib/RemoteResource";

import {
  TRIBUNAL_REVIEW_CREATE_REQUESTED,
  TRIBUNAL_REVIEW_CREATE_FAILED,
  TRIBUNAL_REVIEW_CREATE_SUCCEEDED,
  TRIBUNAL_REVIEW_GET_ALL_REQUESTED,
  TRIBUNAL_REVIEW_GET_ALL_FAILED,
  TRIBUNAL_REVIEW_GET_ALL_SUCCEEDED,
  TRIBUNAL_REVIEW_GET_REQUESTED,
  TRIBUNAL_REVIEW_GET_FAILED,
  TRIBUNAL_REVIEW_GET_SUCCEEDED,
  TRIBUNAL_REVIEW_UPDATE_REQUESTED,
  TRIBUNAL_REVIEW_UPDATE_FAILED,
  TRIBUNAL_REVIEW_UPDATE_SUCCEEDED,
  LEAD_UPDATE_SUCCEEDED,
  TRIBUNAL_REVIEW_DELETE_SUCCEEDED,
  TRIBUNAL_REVIEW_DELETE_FAILED,
  TRIBUNAL_REVIEW_DELETE_REQUESTED,
} from "../actions";

import { getToken } from "./selectors";

function* fetchTribunalReview(action) {
  try {
    const id = action.payload;
    const token = yield select(getToken);
    const tribunalReview = yield call(
      remoteResource.getTribunalReview,
      id,
      token
    );
    yield put({
      type: TRIBUNAL_REVIEW_GET_SUCCEEDED,
      payload: tribunalReview.data,
    });
  } catch (e) {
    yield put({ type: TRIBUNAL_REVIEW_GET_FAILED, payload: e.message });
  }
}

function* fetchAllTribunalReviews(action) {
  try {
    const token = yield select(getToken);
    const tribunalReviews = yield call(
      remoteResource.getAllTribunalReview,
      token
    );
    yield put({
      type: TRIBUNAL_REVIEW_GET_ALL_SUCCEEDED,
      payload: tribunalReviews.data,
    });
  } catch (e) {
    yield put({ type: TRIBUNAL_REVIEW_GET_ALL_FAILED, payload: e.message });
  }
}

function* createTribunalReview(action) {
  try {
    let payload = {};
    let leadId = "";
    if (action.payload && action.payload.payload) {
      payload = action.payload.payload;
    } else {
      payload = action.payload;
    }
    if (action.payload && action.payload && action.payload.leadId) {
      leadId = action.payload.leadId;
    }
    const token = yield select(getToken);
    const tribunalReview = yield call(
      remoteResource.createTribunalReview,
      payload,
      token
    );
    if (leadId && leadId !== "") {
      const lead = yield call(
        remoteResource.updateLeadClient,
        leadId,
        { tribunalReviewId: tribunalReview.data.id },
        token
      );
      yield put({
        type: LEAD_UPDATE_SUCCEEDED,
        payload: lead.data,
      });
    }
    yield put({
      type: TRIBUNAL_REVIEW_CREATE_SUCCEEDED,
      payload: tribunalReview.data,
    });
  } catch (e) {
    yield put({
      type: TRIBUNAL_REVIEW_CREATE_FAILED,
      payload: e.response.data.message,
    });
  }
}

function* updateTribunalReview(action) {
  try {
    const { payload, id } = action.payload;
    const token = yield select(getToken);
    const tribunalReview = yield call(
      remoteResource.updateTribunalReview,
      id,
      payload,
      token
    );
    yield put({
      type: TRIBUNAL_REVIEW_UPDATE_SUCCEEDED,
      payload: tribunalReview.data,
    });
  } catch (e) {
    yield put({
      type: TRIBUNAL_REVIEW_UPDATE_FAILED,
      payload: e.response.data.message,
    });
  }
}

function* deleteTribunalReview(action) {
  try {
    const { id } = action.payload;
    const token = yield select(getToken);
    yield call(remoteResource.deleteTribunalReview, id, token);
    yield put({
      type: TRIBUNAL_REVIEW_DELETE_SUCCEEDED,
    });
  } catch (e) {
    yield put({
      type: TRIBUNAL_REVIEW_DELETE_FAILED,
      payload: e.response.data.message,
    });
  }
}
export function* watchTribunalReview() {
  yield takeLatest(TRIBUNAL_REVIEW_GET_REQUESTED, fetchTribunalReview);
  yield takeLatest(TRIBUNAL_REVIEW_CREATE_REQUESTED, createTribunalReview);
  yield takeLatest(TRIBUNAL_REVIEW_UPDATE_REQUESTED, updateTribunalReview);
  yield takeLatest(TRIBUNAL_REVIEW_GET_ALL_REQUESTED, fetchAllTribunalReviews);
  yield takeLatest(TRIBUNAL_REVIEW_DELETE_REQUESTED, deleteTribunalReview);
}
